import * as angular from 'angular';

import { ConnectionPoint, ConnectionPointTestResult } from '../../models';
import { IConnectionPointActionsService } from './connectionPoints.actionCreator';
import { IDispatcherService, IDispatcher } from '../';

export interface IConnectionPointStoreService {
    getAll: (force?: boolean) => angular.IPromise<ConnectionPoint[]>;
    deleteOne: (guid: string) => angular.IPromise<number>;
    duplicate: (guid: string) => angular.IPromise<ConnectionPoint>;
    testAll: (force?: boolean) => angular.IPromise<ConnectionPointTestResult[]>;
    test: (guid: string, force?: boolean) => angular.IPromise<boolean>;
    updateOne: (connectionPoint: ConnectionPoint, isDatabaseCreationRequested: boolean) => angular.IPromise<ConnectionPoint>;
}

export interface IConnectionPointActionDispatcherService extends IDispatcherService<IConnectionPointStoreService> { }

export class ConnectionPointActionDispatcherService implements IConnectionPointActionDispatcherService {
    static serviceId = 'connectionPointActionDispatcherService';

    static $inject = ['connectionPointActionsService'];

    constructor(private _actionService: IConnectionPointActionsService) { }

    getDispatcher(dispatch: Function): IDispatcher<IConnectionPointStoreService> {
        const actionService = this._actionService;

        return {
            dispatcher: {
                getAll: (force?: boolean) => dispatch(actionService.getAll(force)),
                deleteOne: (guid: string) => dispatch(actionService.deleteOne(guid)),
                duplicate: (guid: string) => dispatch(actionService.duplicate(guid)),
                testAll: (force?: boolean) => dispatch(actionService.testAll(force)),
                test: (guid: string, force?: boolean) => dispatch(actionService.test(guid, force)),
                updateOne: (cp: ConnectionPoint, isDBCreate: boolean) => dispatch(actionService.updateOne(cp, isDBCreate))
            }
        };
    }
}